import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHyperstarFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M7.246.496q.48 0 .921.04v1.408a9 9 0 0 0-.92-.048c-2.195 0-3.457.715-4.2 1.606-.779.935-1.15 2.266-1.15 3.745s.371 2.809 1.15 3.744c.743.89 2.005 1.606 4.2 1.606 2.194 0 3.455-.715 4.197-1.606.78-.935 1.152-2.265 1.152-3.744q0-.469-.051-.914h1.408q.043.456.043.914c0 1.6-.38 3.201-1.318 4.442l2.822 2.82-.99.991-2.816-2.815c-1.045.81-2.496 1.312-4.448 1.312-5.062 0-6.75-3.375-6.75-6.75S2.184.497 7.246.497"
                        fill="currentColor"
                    />
                    <path
                        d="M12 0a9.5 9.5 0 0 0 2.5 2.5A9.5 9.5 0 0 0 12 5a9.5 9.5 0 0 0-2.5-2.5A9.5 9.5 0 0 0 12 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierOutlinedHyperstarFilledSize16Glyph.displayName = 'MagnifierOutlinedHyperstarFilledSize16Glyph';
